import { useQuery } from "@tanstack/react-query"
import type { MediaKind, MediaRef } from "@velizhanin-dev/bot-scenario"
import { AudioLines, Circle, FileText, Film, ImageIcon, Mic, Smile, Video } from "lucide-react"
import type { MediaSource } from "@/entities/bot-builder"

const MEDIA_ICONS: Record<MediaKind, typeof ImageIcon> = {
	photo: ImageIcon,
	video: Video,
	animation: Film,
	audio: AudioLines,
	voice: Mic,
	video_note: Circle,
	document: FileText,
	sticker: Smile,
}

export function Thumbnail({
	source,
	media,
	size = "h-12 w-12",
}: {
	source: MediaSource
	media: MediaRef
	size?: string
}) {
	// Файл только в Telegram (перенесён из другого конструктора) превью из хранилища не имеет.
	const s3Key = media.s3Key
	const preview = useQuery({
		queryKey: [...source.cacheKey, s3Key],
		queryFn: () => source.previewUrl(s3Key as string),
		enabled: !!s3Key && (media.kind === "photo" || media.kind === "sticker"),
		staleTime: 30 * 60_000,
	})
	const Icon = MEDIA_ICONS[media.kind] ?? FileText
	if ((media.kind === "photo" || media.kind === "sticker") && preview.data) {
		return <img src={preview.data.url} alt="" className={`${size} shrink-0 rounded object-cover`} />
	}
	return (
		<span className={`${size} flex shrink-0 items-center justify-center rounded bg-muted`}>
			<Icon className="h-5 w-5 text-muted-foreground" />
		</span>
	)
}
